howspace.components.time = (() => {
    'use strict';

    const weekdays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

    const shiftWeekday = (weekday, days) => {
        const index = weekdays.indexOf(weekday);
        return index === -1 ? weekday : weekdays[(index + days + 7) % 7];
    };

    // How many days the UTC calendar date is ahead of the browser-local one for the given moment: -1, 0 or 1.
    const getUtcDayShift = date => {
        const utcDay = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
        const browserDay = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
        return Math.round((utcDay - browserDay) / 86400000);
    };

    // UI languages are mostly BCP 47 tags already. Howspace English is British.
    const getLanguageAsBCP47 = () => {
        const language = real.locale.getLanguage().replace(/-formal$/, '');
        return language === 'en' ? 'en-GB' : language;
    };

    const toLocale = time => {
        try {
            if (!time.attr('datetime')) {
                return;
            }
            const date = new Date(time.attr('datetime'));

            // Weekday names come from the UI language like the rest of the UI, not from the date locale.
            if (time.data('show-weekday') === true) {
                const weekdayNames = [
                    howspace.translate('common_sunday'),
                    howspace.translate('common_monday'),
                    howspace.translate('common_tuesday'),
                    howspace.translate('common_wednesday'),
                    howspace.translate('common_thursday'),
                    howspace.translate('common_friday'),
                    howspace.translate('common_saturday'),
                ];
                time.text(weekdayNames[date.getDay()]);
                return;
            }

            const options = {};

            if (time.data('show-date') !== false) {
                options.year = 'numeric';
                options.month = 'numeric';
                options.day  = 'numeric';
            }

            if (time.data('show-time') !== false) {
                options.hour = 'numeric';
                options.minute = 'numeric';
            }

            const locale = real.locale.getLocaleAsBCP47();
            const shown = date.toLocaleString(locale, options);
            time.text(shown);
            if (options.month === undefined) {
                return;
            }

            // Screen readers spell out a numeric date digit by digit, so they get the month name instead.
            // The month name follows the UI language and the clock follows the date locale like the shown time.
            const {hourCycle} = new Intl.DateTimeFormat(locale, {hour: 'numeric'}).resolvedOptions();
            const spoken = date.toLocaleString(getLanguageAsBCP47(), {...options, month: 'long', hourCycle});
            time.empty().append(
                $('<span aria-hidden="true"></span>').text(shown),
                $('<span class="sr-only"></span>').text(spoken)
            );
        } catch (e) {
            // Converting date to locale string failed. Leave the UI as is.
            console.log('Could not show', time.attr('datetime'), 'as locale string.', e);
        }
    };

    return {
        init: (elem) => {
            // Init times shown on display.
            elem.findIncludingSelf('.howspace-time:not(.howspace-time-initialized)').each(function () {
                const time = $(this);

                time.addClass('howspace-time-initialized');

                toLocale(time);
            });

            // Init times shown in tooltips.
            elem.findIncludingSelf('.howspace-time-tooltip:not(.howspace-time-tooltip-initialized)').each(function () {
                const timeTooltip = $(this);

                timeTooltip.addClass('howspace-time-tooltip-initialized');

                // Create a helper div element and put the tooltip content as its html.
                const helper = $('<div/>');
                helper.html(timeTooltip.data('title'));

                // Init all howspace time elements within the helper.
                howspace.components.time.init(helper);

                // Convert all howspace time elements inside the tooltip as plain text.
                helper.findIncludingSelf('.howspace-time.howspace-time-initialized').each(function() {
                    let time = $(this);
                    time.replaceWith(howspace.components.time.getShownText(time));
                });

                // Update the tooltip title attribute.
                timeTooltip.dataAndAttr('title', helper.html());
            });
        },
        destroy: (elem) => {
            elem.findIncludingSelf('.howspace-time.howspace-time-initialized').each(function () {
                const time = $(this);
                time.removeClass('howspace-time-initialized');
            });

            elem.findIncludingSelf('.howspace-time-tooltip.howspace-time-tooltip-initialized').each(function () {
                const timeTooltip = $(this);
                timeTooltip.removeClass('howspace-time-tooltip-initialized');
            });
        },

        // The time as shown on screen, without the text only screen readers get.
        getShownText: time => {
            const shown = time.children('[aria-hidden="true"]');
            return shown.length > 0 ? shown.text() : time.text();
        },

        // Convert a browser-local "HH.MM" time of day to its UTC "HH.MM" equivalent (today's offset).
        getUtcTime: (time) => {
            const [hours, minutes] = time.split(".");

            const browserDate = new Date();
            browserDate.setHours(hours, minutes);

            return browserDate.getUTCHours().toString().padStart(2, '0') + '.' +
                browserDate.getUTCMinutes().toString().padStart(2, '0');
        },

        // Convert a UTC "HH.MM" time of day to its browser-local "HH.MM" equivalent (today's offset).
        getBrowserTime: (time) => {
            const [hours, minutes] = time.split(".");

            const browserDate = new Date();
            browserDate.setUTCHours(hours, minutes);

            return browserDate.getHours().toString().padStart(2, '0') + '.' +
                browserDate.getMinutes().toString().padStart(2, '0');
        },

        // Convert a browser-local weekday and "HH.MM" time to UTC. The weekday moves when the offset crosses midnight.
        getUtcWeekdayTime: (weekday, time) => {
            const [hours, minutes] = time.split(".");

            const browserDate = new Date();
            browserDate.setHours(hours, minutes);

            return {
                weekday: shiftWeekday(weekday, getUtcDayShift(browserDate)),
                time: howspace.components.time.getUtcTime(time)
            };
        },

        // Convert a UTC weekday and "HH.MM" time to the browser-local equivalent (today's offset).
        getBrowserWeekdayTime: (weekday, time) => {
            const [hours, minutes] = time.split(".");

            const browserDate = new Date();
            browserDate.setUTCHours(hours, minutes);

            return {
                weekday: shiftWeekday(weekday, -getUtcDayShift(browserDate)),
                time: howspace.components.time.getBrowserTime(time)
            };
        }
    };

})();
